// Languages Resources
import { Lang_Types } from '../../../main/constants';
import englishLang from '../../../main/i18n/resources.en.json';
import spanishLang from '../../../main/i18n/resources.es.json';
import defaultLang from '../../../main/i18n/resources.json';

export const setLanguageUseCase = (lang: string) => {
    switch (lang) {
        case Lang_Types['ES-CO']:
            return spanishLang;

        case Lang_Types['EN-US']:
            return englishLang;
        default:
            return defaultLang;
    }
};
